import {
  TECH_ORDER_TAB,
  TECH_ORDER_OBJ,
  TECH_ALLOWED_ACTIONS,
  TECH_APP_PROFILE,
  TECH_APP_TRANSACTIONS,
  TECH_APP_TICKET_STATUS,
  TECH_APP_TICKET_DATA,
  TECH_APP_UNREAD_MESSAGES,
  TECH_APP_SHOW_UNREAD,
  TECH_APP_HINTS,
  TECH_APP_SETTINGS,
} from "../Actions/TechAppAction";

const initialState = {
  profileData: null,
  techOrderTab: 4,
  orderObj: null,
  ticketObj: null,
  allowedActions: null,
  transactionsData: null,
  ticketStatus: 0,
  unreadMessages: [],
  showUnread: true,
  hints: [],
  settings: null,
};

const TechAppReducer = (state = initialState, action) => {
  switch (action.type) {
    case TECH_APP_PROFILE:
      return { ...state, profileData: action.payload };
    case TECH_ORDER_TAB:
      return { ...state, techOrderTab: action.payload };
    case TECH_ORDER_OBJ:
      return { ...state, orderObj: action.payload };
    case TECH_ALLOWED_ACTIONS:
      return { ...state, allowedActions: action.payload };
    case TECH_APP_TRANSACTIONS:
      return { ...state, transactionsData: action.payload };
    case TECH_APP_TICKET_STATUS:
      return { ...state, ticketStatus: action.payload };
    case TECH_APP_TICKET_DATA:
      return { ...state, ticketObj: action.payload };
    case TECH_APP_UNREAD_MESSAGES:
      return { ...state, unreadMessages: action.payload };
    case TECH_APP_SHOW_UNREAD:
      return { ...state, showUnread: action.payload };
    case TECH_APP_HINTS:
      return { ...state, hints: action.payload };
    case TECH_APP_SETTINGS:
      return { ...state, settings: action.payload };
    default:
      return state;
  }
};
export default TechAppReducer;
